import { useLettersStore } from '@lib/store';
import { cn } from '@shared/utils';
import LetterIcon from '@assets/images/letters-icon.svg';
import LetterMobileIcon from '@assets/images/letters-icon_mobile.svg';
import AttentionIcon from '@assets/images/attention-icon.svg';
import AttentionMobileIcon from '@assets/images/attention-icon_mobile.svg';
import ArchiveIcon from '@assets/images/archive-icon.svg';
import ArchiveMobileIcon from '@assets/images/archive-icon_mobile.svg';
import SendIcon from '@assets/images/send-message-icon.svg';
import SendMobileIcon from '@assets/images/send-message-icon_mobile.svg';
import HandIcon from '@assets/images/hand_mobile.svg';

const MENU = [
  {
    type: '',
    text: 'Letters',
    icon: <LetterIcon className='max-md:hidden' />,
    iconMobile: <LetterMobileIcon className='max-md:inherit hidden' />,
    counter: true,
  },
  {
    type: 'important',
    text: 'Important',
    icon: <AttentionIcon className='max-md:hidden' />,
    iconMobile: <AttentionMobileIcon className='max-md:inherit hidden' />,
  },
  {
    type: 'archive',
    text: 'Archive',
    icon: <ArchiveIcon className='max-md:hidden' />,
    iconMobile: <ArchiveMobileIcon className='max-md:inherit hidden' />,
  },
  {
    type: 'outgoing',
    text: 'Sent',
    icon: <SendIcon className='max-md:hidden' />,
    iconMobile: <SendMobileIcon className='max-md:inherit hidden' />,
  },
];

interface ILetterMenuProps {
  className?: string;
  filter: string;
  onFilter: (filter: string) => void;
}

export const LetterMenu = (props: ILetterMenuProps) => {
  const { data } = useLettersStore();

  return (
    <div className={cn('mt-6', 'max-md:relative max-md:m-0 max-md:flex max-md:w-full max-md:items-center max-md:overflow-x-scroll', props.className)}>
      <HandIcon className='max-md:inherit absolute top-0 left-0 hidden' />
      {MENU.map((item, idx) => {
        const unreadMessages = item.counter && data?.filter((letter) => !letter.archive && !letter.read).length;
        return (
          <div
            key={idx}
            className={cn(
              'flex cursor-pointer items-center pt-2 pr-8 pb-2 pl-23.75 text-xl font-medium text-[#4c4c4c] hover:underline',
              'max-md:m-0 max-md:ml-3 max-md:items-center max-md:px-3 max-md:py-2 max-md:hover:no-underline',
              idx === 0 && 'max-md:ml-12!',
              item.type === props.filter && 'bg-[#e4c4965c] max-md:rounded-3xl',
            )}
            onClick={() => props.onFilter(item.type)}
          >
            {item.icon}
            {item.iconMobile}
            <p className='pl-5 max-md:pl-4'>{item.text}</p>
            {!!unreadMessages && <div className='h-[29px] w-[15px] pl-1 text-xl text-[#d0021b]'>{unreadMessages}</div>}
          </div>
        );
      })}
    </div>
  );
};
